import styled from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import { spacing } from '@nubank/nuds-web/styles/themeUtils';

export const StyledEmailProviderBox = styled(Box)`
  white-space: nowrap;
  overflow: auto;
  padding: ${spacing('6x')};
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
}
`;

StyledEmailProviderBox.displayName = 'StyledEmailProviderBox';
